/**
 * @generated SignedSource<<df2e480c37ecf4f566bbac5d092a7d5e>>
 * @relayHash 20d9cf941bf372501c1c291fc568e8f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4bbc2eebecb28bccd13be945dc4fae1dbc3a56cf2111e2cc61f346067f80bd9c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormEditQuery } from './FormEditQuery.graphql';

const node: PreloadableConcreteRequest<FormEditQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4bbc2eebecb28bccd13be945dc4fae1dbc3a56cf2111e2cc61f346067f80bd9c",
    "metadata": {},
    "name": "FormEditQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
